export default {
  title: "Search",
  subtitle: "Search for patients, samples, and results",
  comingSoon: "Coming Soon",
  description:
    "This feature will provide comprehensive search across patients, samples, and results.",
};
